import { createContext, useContext, useEffect } from "react";
import useDataPersistent from "../hooks/usedataPersistant";

const PflanzenBProgressContext = createContext({});

export const PflanzenBProgressContextProvider = ({ children }) => {
    const markersIds = [
        "pflanzenB-lola-message-icon",
        "pflanzenB-lola-message-1",
        "pflanzenB-lola-message-2",
        "pflanzenB-lola-message-3",
        "learn-pflanzenB-html-marker-deer",
        "garbage-apple", "garbage-bottle", "garbage-plasticBag",
        "garbage-can", "garbage-bananaPeel", "garbage-pickleJar",
        "garbage-paper", "garbage-plasticCup"
    ];

    const [clickedMarkers, setClickedMarkers] = useDataPersistent(
        "clickedMarkersPflanzenB",
        []
    );

    const [progress, setProgress] = useDataPersistent("progressPflanzenB", 0);

    // Calculate progress whenever clickedMarkers changes
    useEffect(() => {
        const validMarkers = clickedMarkers.filter(marker =>
            markersIds.includes(marker)
        );
        const uniqueMarkers = [...new Set(validMarkers)]; // Remove duplicates
        const currentProgress = uniqueMarkers.length / markersIds.length;
        setProgress(currentProgress);
    }, [clickedMarkers, markersIds.length, setProgress]);

    const countPercentage = (id) => {
        if (!markersIds.includes(id)) {
            return progress; // Return current progress if invalid ID
        }

        // Update clicked markers (automatically triggers progress update via useEffect)
        setClickedMarkers(prev => {
            const newMarkers = [...prev, id];
            return [...new Set(newMarkers)]; // Ensure no duplicates
        });

        return progress; // The useEffect will handle the progress update
    };

    return (
        <PflanzenBProgressContext.Provider value={{
            countPercentage,
            clickedMarkers,
            progress
        }}>
            {children}
        </PflanzenBProgressContext.Provider>
    );
};

export const usePflanzenBProgress = () => {
    return useContext(PflanzenBProgressContext);
};